import React from 'react'
import { PromptStyle } from '@pushly/models/lib/enums'

type PromptStyleDiagramProps = {
    style: PromptStyle
}

/**
 * Where each prompt style appears in the browser, as a window outline with the
 * prompt filled in. Deliberately schematic — it answers "where does this show up
 * and who designs it", not "what will it look like".
 *
 * Drawn in `currentColor` so it takes the colour of the tile slot it sits in,
 * which is theme-aware — no second copy of the artwork for dark mode.
 */
export const PromptStyleDiagram = ({ style }: PromptStyleDiagramProps) => (
    <svg width="60" height="44" viewBox="0 0 60 44" role="presentation" focusable="false">
        <g opacity="0.35" stroke="currentColor">
            <rect x="0.5" y="0.5" width="59" height="43" rx="3" fill="none" />
            <line x1="0" y1="10.5" x2="60" y2="10.5" />
        </g>
        <g fill="currentColor" opacity="0.35">
            <circle cx="6" cy="5.5" r="1.5" />
            <circle cx="11" cy="5.5" r="1.5" />
            <circle cx="16" cy="5.5" r="1.5" />
        </g>

        {/* The browser's own permission dialog, which it anchors under the address bar. */}
        {style === PromptStyle.NATIVE && (
            <rect x="5" y="14" width="26" height="15" rx="2" fill="currentColor" opacity="0.7" />
        )}
        {/* A panel of ours. Square along the top edge, so it reads as having slid down from it. */}
        {style === PromptStyle.SLIDE && (
            <path d="M15 11 H45 V21 a2 2 0 0 1 -2 2 H17 a2 2 0 0 1 -2 -2 Z" fill="currentColor" opacity="0.7" />
        )}
        {/* Drawn as an empty outline: the publisher supplies this one. */}
        {style === PromptStyle.PUBLISHER_CUSTOM && (
            <rect
                x="18.5"
                y="20.5"
                width="23"
                height="14"
                rx="2"
                fill="none"
                stroke="currentColor"
                strokeDasharray="3 2"
                opacity="0.7"
            />
        )}
    </svg>
)
